<template>
  <v-stepper v-model="stepper" class="elevation-0">
    <v-stepper-header class="elevation-0" style="padding-bottom: 8px;">
      <v-stepper-step :complete="stepper > 1" step="1"
        >Download app</v-stepper-step
      >

      <v-divider></v-divider>

      <v-stepper-step :complete="stepper > 2" step="2"
        >Scan QR-code</v-stepper-step
      >

      <v-divider></v-divider>

      <v-stepper-step :complete="stepper > 3" step="3"
        >Backup your code</v-stepper-step
      >

      <v-divider></v-divider>

      <v-stepper-step :complete="stepper > 4" step="4">Verify</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <p class="desc">
          Enable 2 factor authentication to increase your account's security.
        </p>
        <p class="desc">
          Download a compatible 2 factor authenticator app on your smartphone
          and click the button below to begin.
        </p>
        <div style="margin-top: 30px;">
          <a
            href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
            style="display: inline-block;"
          >
            <img
              alt="Get it on Google Play"
              src="https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png"
              width="150px"
              style="margin-left: -10px;"
            />
          </a>
          <a
            href="https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8"
            style="display:inline-block;overflow:hidden;background:url(https://linkmaker.itunes.apple.com/en-us/badge-lrg.svg?releaseDate=2010-09-20&kind=iossoftware&bubble=apple_music) no-repeat;width:135px;height:48px;"
          ></a>
        </div>

        <v-btn
          color="primary"
          class="ml-0"
          :disabled="loading"
          @click="requestSecret"
          >Continue</v-btn
        >
      </v-stepper-content>

      <v-stepper-content step="2" style="padding-top: 8px; padding-bottom: 8px">
        <div>
          <div class="div-left">
            <img :src="qrCode" style="max-width: 189px;" />
          </div>
          <div class="div-right">
            <p class="scan">Scan this QR code with your authenticator app.</p>
            <p class="qr-desc">
              If you are unable to scan the QR-code, please enter this code
              manually:
            </p>
            <p class="lighten-4 pa-3 body-2 secret">{{ secret }}</p>
          </div>
        </div>
        <v-btn
          color="primary"
          class="ml-0 btn-big"
          style="margin-bottom: 16px !important; margin-top: 36px !important;"
          @click="stepper = 3"
          >I have scanned the QR-code</v-btn
        >
        <v-btn
          flat
          class="btn-back btn-back-step-2"
          @click="stepper = 1"
          >Back</v-btn
        >
      </v-stepper-content>

      <v-stepper-content step="3" class="pt-0">
        <p class="lighten-4 pa-3 body-2 secret">{{ secret }}</p>

        <p class="text mt-4">
          Please write down the secret somewhere safe, you need it in case you
          lose your phone.
        </p>

        <p class="text-warn mb-3">
          If you lose your phone and 2fa secret you need to contact support.
          Restoring access to your account can take some time.
        </p>

        <v-btn color="primary" class="ml-0 btn-big" @click="stepper = 4"
          >I have written down the secret</v-btn
        >
        <v-btn flat class="btn-back btn-back-step-3" @click="stepper = 2">Back</v-btn>
      </v-stepper-content>

      <v-stepper-content step="4" style="padding-top: 7px;">
        <p class="form-desc">
          To verify that you did everything right please enter your password
          and, using the authenticator app, a valid 2fa code below.
        </p>

        <div>
          <v-text-field
            v-model="verifyForm.password"
            :type="verifyForm.passwordShow ? 'text' : 'password'"
            name="verifyFormPassword"
            label="Password"
          >
            <template v-slot:append>
              <img
                width="24"
                height="24"
                :src="password_icon"
                @click="togglePassword"
              />
            </template>
          </v-text-field>
          <v-text-field
            v-model="verifyForm.code"
            name="verifyFormCode"
            label="2fa code"
            @keyup.enter="verify"
          ></v-text-field>
        </div>

        <v-btn color="primary" class="ml-0" :disabled="loading" @click="verify"
          >Verify</v-btn
        >
        <v-btn flat class="btn-back btn-back-step-4" @click="stepper = 1">Back to start</v-btn>
      </v-stepper-content>

      <v-stepper-content step="5">
        <div style="margin-top: 28px; margin-bottom: 32px;">
          <div class="text-xs-center">
            <span class="done-title">
              Done
              <v-img
                class="ml-2"
                src="/img/done_active.svg"
                width="24"
                style="display: inline-flex;"
              />
            </span>
          </div>
          <div class="text-xs-center mt-3">
            <p class="done-text">
              Alright, your account is now extra secure. Keep your secret safe
              <br />
              in case you lose your phone!
            </p>
          </div>
        </div>
        <v-btn class="ml-0" style="margin-top: 64px;" :disabled="loading" @click="updateUserData"
          >Disable 2FA</v-btn
        >
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<style scoped>
.btn-back-step-2 {
  margin-bottom: 0px !important;
  margin-top: 20px !important;
}
.btn-back-step-3 {
  margin-top: 50px !important;
}
.btn-back-step-4 {
  margin-top: 50px !important;
}
.v-btn {
  margin-top: 50px;
}
.btn-back {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #103a84 !important;
  background: #e6efff;
  border-radius: 30px;
  width: 147px;
  height: 44px;
  margin: 12px 6px 8px;
  box-shadow: none !important;
}
.btn-big {
  width: 277px !important;
}
.theme--light >>> .v-stepper__step.v-stepper__step--active .v-stepper__label {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #103a84;
  text-shadow: none;
}
.theme--light >>> .v-stepper__label {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #8691a4;
}
.theme--light >>> .v-stepper__step__step.primary {
  background-color: #7ec171 !important;
  border-color: #7ec171 !important;
}
.theme--light >>> .v-stepper__step__step {
  background-color: #8691a4 !important;
  border-color: #8691a4 !important;
}
.theme--light p.desc {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #103a84;
}
.theme--light p.scan {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #103a84;
}
.theme--light p.qr-desc {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 130%;
  color: #7395d0;
  margin-top: 32px;
}
.theme--light p.secret {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #536580;
  margin-top: 16px;
  background: #f0f2f5;
  border-radius: 1px;
}
.theme--light >>> .v-stepper__step {
  padding-top: 8px;
  padding-bottom: 8px;
}
.theme--light p.text {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 130%;
  color: #7395d0;
}
.theme--light p.text-warn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #f2994a;
  margin-top: 22px;
}
.theme--light p.form-desc {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #103a84;
}
.theme--light .done-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 34px;
  text-align: center;
  color: #103a84;
}
.theme--light .done-text {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  text-align: center;
  color: #103a84;
}

.div-right {
  float: right;
  width: 66%;
  padding-left: 20px;
  padding-top: 14px;
}
.div-left {
  display: inline-block;
  width: 34%;
}
@media only screen and (max-width: 959px) {
  .theme--light.v-stepper .v-stepper__step--active >>> .v-stepper__label {
    display: flex !important;
    font-family: "Lato", serif !important;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #103a84;
    text-shadow: none;
    margin-left: 12px;
  }
}
@media (max-width: 670px) {
  .div-left {
    display: inline-block;
    width: 99%;
    text-align: center !important;
  }
  .div-right {
    float: none;
    width: 99%;
    padding-left: 20px;
    padding-top: 14px;
  }
}
@media (max-width: 450px) {
  .btn-back-step-2 {
    margin-bottom: 0px !important;
    margin-top: 8px !important;
  }
  .btn-back-step-3 {
    margin-top: 8px !important;
  }
  .btn-back-step-4 {
    margin-top: 8px !important;
  }
}
/********/
.theme--dark .v-stepper {
  background: #212121;
}
.theme--dark
  >>> .v-stepper__step.v-stepper__step--complete
  .v-stepper__step__step.primary
  .v-icon {
  color: #000000;
}
.theme--dark >>> .v-stepper__step.v-stepper__step--active .v-stepper__label {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #e9e9e9;
  text-shadow: none;
}
.theme--dark >>> .v-stepper__label {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: rgba(235, 235, 245, 0.3);
}
.theme--dark >>> .v-stepper__step__step.primary {
  background-color: #7ec171 !important;
  border-color: #7ec171 !important;
  color: #000000;
}
.theme--dark >>> .v-stepper__step__step {
  background-color: rgba(235, 235, 245, 0.3) !important;
  border-color: rgba(235, 235, 245, 0.3) !important;
}
.theme--dark p.desc {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #e9e9e9;
}
.theme--dark p.scan {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #e9e9e9;
}
.theme--dark p.qr-desc {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 130%;
  color: rgba(235, 235, 245, 0.6);
  margin-top: 32px;
}
.theme--dark p.secret {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #959596;
  margin-top: 16px;
  background: #303030;
  border-radius: 1px;
}
.theme--dark >>> .v-stepper__step {
  padding-top: 8px;
  padding-bottom: 8px;
}
.theme--dark p.text {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 130%;
  color: rgba(235, 235, 245, 0.6);
}
.theme--dark p.text-warn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #f2994a;
  margin-top: 22px;
}
.theme--dark p.form-desc {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #e9e9e9;
}
.theme--dark .done-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 34px;
  text-align: center;
  color: #e9e9e9;
}
.theme--dark .done-text {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  text-align: center;
  color: #e9e9e9;
}
.theme--dark .btn-back {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #e9e9e9 !important;
  background: #454547;
  border-radius: 30px;
  width: 147px;
  height: 44px;
  margin: 12px 6px 8px;
  box-shadow: none !important;
}
</style>
<script>
import axios from "axios";
import swal from "sweetalert2";
import { mapGetters } from "vuex";

export default {
  name: "TwoFactorEnable",
  props: ["skip"],
  data: function() {
    return {
      loading: false,
      stepper: 0,
      qrCode: null,
      secret: null,
      verifyForm: {
        password: null,
        passwordShow: false,
        code: null
      },
      password_icon: "/img/eye-icon.svg"
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      themeDark: "settings/darkmode"
    })
  },
  created: function() {
    if (this.skip) {
      this.stepper = 2;
      this.requestSecret();
    }
  },
  methods: {
    reload: function() {
      window.location.reload();
    },
    updateUserData: async function() {
      this.$set(this.user, "google_2fa_enabled", true);
      this.$emit("updateEnableSkipSteps", {
        skipEnableStepOne: true
      });
      await this.$store.dispatch("auth/updateUser", this.user);
    },
    requestSecret: async function() {
      this.loading = true;

      const { data } = await axios.post("api/v1/two-factor/enable");

      this.qrCode = data.qr_code;
      this.secret = data.secret;

      this.loading = false;
      this.stepper = 2;
    },
    verify: async function() {
      this.loading = true;

      // validate form

      // enable
      try {
        const { data } = await axios.post("api/v1/two-factor/verify", {
          password: this.verifyForm.password,
          "2fa_code": this.verifyForm.code
        });

        this.loading = false;
        this.stepper = 5;
      } catch (error) {
        this.verifyForm.password = null;
        this.verifyForm.code = null;

        await swal({
          title: "2fa not enabled",
          text: "Unable to verify, please retry",
          showConfirmButton: false,
          showCloseButton: true,
          customClass: this.themeDark ? "swal-type-error-dark" : "swal-type-error",
          imageUrl: "/img/popup_img_error.png",
          imageHeight: 80,
          imageWidth: 80
        });

        this.loading = false;
        return false;
      }
    },
    togglePassword() {
      this.verifyForm.passwordShow = !this.verifyForm.passwordShow;
      this.password_icon =
        this.verifyForm.passwordShow === "password"
          ? "/img/eye-icon.svg"
          : "/img/eye-open-icon.svg";
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/settings/TwoFactorEnable.vue